import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AutoSaveComponent } from './autosave.component';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [
    AutoSaveComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    PipesModule
  ],
  exports: [
    AutoSaveComponent
  ]
})
export class AutoSaveModule { }
